"use client";

type ClientSignalBucket = {
  count: number;
  windowStartedAt: number;
};

const DEFAULT_WINDOW_MS = 60_000;
const DEFAULT_LIMIT = 10;
const buckets = new Map<string, ClientSignalBucket>();

export function shouldCapturePostHogClientSignal(
  key: string,
  options?: { limit?: number; windowMs?: number },
): boolean {
  const now = Date.now();
  const limit = options?.limit ?? DEFAULT_LIMIT;
  const windowMs = options?.windowMs ?? DEFAULT_WINDOW_MS;
  const bucket = buckets.get(key);

  if (!bucket || now - bucket.windowStartedAt >= windowMs) {
    buckets.set(key, { count: 1, windowStartedAt: now });
    return true;
  }

  if (bucket.count >= limit) {
    return false;
  }

  bucket.count += 1;
  return true;
}

export function resetPostHogClientSignalRateLimitsForTests(): void {
  buckets.clear();
}
